import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Auth from './auth/App.vue'
// import { authPassword } from './app.config'
import { firstLetterCapitalize } from './helpers/keycloak'

let realmTenant = window.location.pathname
  .replace(/\/\//g, '/')
  .replace(/^\/([^\/]*).*$/, '$1')

// TODO does it make sense to set default realm to 'neela'?
realmTenant = realmTenant || 'Standard'

global.realm_tenant = firstLetterCapitalize(realmTenant)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL + realmTenant,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    }
    /*
    , {
      path: '/auth',
      name: 'auth',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: Auth
    }
    */
  ]
})
